import React, { useContext } from "react";
import PropType from "prop-types";

import { Route } from "react-router-dom";
import { AuthContext } from "../AuthContext";

export default function ContentSubRoute({ component: Component, ...rest }) {
  const { getUser } = useContext(AuthContext);

  const user = getUser();

  console.log(user);

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route {...rest} render={(props) => <Component {...props} />} />
  );
}

ContentSubRoute.propTypes = {
  component: PropType.func.isRequired,
};
